<template>
  <v-container fluid>
    <v-row
      v-if="esAdmin"
      class="mb-4"
    >

      <v-col cols="12" md="4">
        <v-select
          v-model="filtros.proveedor"
          :items="listaProveedores"
          label="Proveedor"
          clearable
          dense
          outlined
        />
      </v-col>

      <v-col cols="12" md="4">
        <v-select
          v-model="filtros.contratista"
          :items="listaContratistas"
          label="Contratista"
          clearable
          dense
          outlined
        />
      </v-col>

      <v-col cols="12" md="4">
        <v-select
          v-model="filtros.estado"
          :items="listarEstados"
          label="Estado"
          clearable
          dense
          outlined
        />
      </v-col>

    </v-row>
    <v-row>

      <!-- REQUERIMIENTOS -->
      <v-col
        v-for="req in requerimientosFiltrados"
        :key="req.idrequerimiento"
        cols="12"
      >
        <v-card outlined class="mb-6">

          <!-- HEADER -->
          <v-card-title class="blue-grey lighten-5">
            <div>
              <div class="req-title">
                <strong>{{ req.denominacion.slice(0, 3) }}</strong>
                <span class="grey--text"> - {{ req.empresa_contacto }}</span>
                <v-chip x-small class="ml-1">
                  {{ req.nombre_categoria }}
                </v-chip>
              </div>
              <div class="req-subtitle">
                <span class="grey--text">{{ detallesTextoServicio(req.detalles) }} ({{ detallesTexto(req.detalles) }})</span>
                <v-icon small class="ml-2">mdi-calendar</v-icon>
                {{ formatearFecha(req.fecha_inicio) }}
              </div>
            </div>
          </v-card-title>

          <v-card-text>

            <!-- EMPRESAS -->
            <div
              v-for="empresa in req.empresas"
              :key="empresa.id_empresa"
              class="mb-6"
            >
              <v-alert dense text color="#0095A9">
                Empresa adjudicada:
                <strong>{{ empresa.razonsocial }}</strong>
              </v-alert>

              <!-- TABLA COTIZACIONES -->
              <v-simple-table dense>
                <thead>
                  <tr>
                    <th>Versión</th>
                    <th>Monto</th>
                    <th>Fecha Aprobado por Contratista</th>
                    <th>Estado</th>
                    <th>Observación</th>
                    <!-- <th class="text-center">Acción</th> -->
                  </tr>
                </thead>

                <tbody>

                  <tr
                    v-for="cot in empresa.cotizaciones"
                    :key="cot.id_cotizacion"
                  >
                    <td>V{{ cot.version }}</td>
                    <td>S/ {{ cot.monto }}</td>
                    <td>{{ formatFecha(cot.fecha_envio) }}</td>

                    <td>
                      <span
                        class="badge"
                        :class="estadoClase(cot.estado)"
                      >
                        {{ cot.estado }}
                      </span>
                    </td>

                    <td>{{ cot.observacion || '-' }}</td>

                    <!-- <td class="text-center">
                      <div
                        v-if="
                          esTransporteLiviano(req)
                        "
                      >
                        <v-btn
                          color="primary"
                          small
                          @click="
                            abrirModal(req,empresa)
                          "
                          v-if="
                            puedeSubir(
                              empresa.cotizaciones
                            )
                          "
                        >
                          Subir valorización
                        </v-btn>
                      </div>
                      <div v-else-if="esUltima(cot, empresa) && cot.estado === 'PENDIENTE'">
                        <v-btn
                          small
                          class="btn-aprobar mr-2"
                          @click="aprobar(cot)"
                        >
                          <v-icon small left>mdi-check</v-icon>
                          Aprobar
                        </v-btn>

                        <v-btn
                          small
                          class="btn-observar"
                          @click="abrirObservacion(cot)"
                        >
                          <v-icon small left>mdi-alert</v-icon>
                          Observar
                        </v-btn>

                      </div>

                      <span v-else>-</span>

                    </td> -->
                  </tr>

                  <tr v-if="!empresa.cotizaciones.length">
                    <td colspan="6" class="text-center grey--text">
                      No existen valorizaciones
                    </td>
                  </tr>

                </tbody>
              </v-simple-table>
            </div>

          </v-card-text>
        </v-card>
      </v-col>

      <!-- VACÍO -->
      <v-col v-if="!requerimientosFiltrados.length" cols="12">
        <v-alert type="warning" text>
          No existen requerimientos adjudicados
        </v-alert>
      </v-col>

    </v-row>

    <!-- MODAL OBSERVAR -->
    <v-dialog v-model="dialogObs" max-width="500">
      <v-card>
        <v-card-title>
          Observar valorización
        </v-card-title>

        <v-card-text>
          <v-textarea
            label="Ingrese observación"
            v-model="observacion"
            outlined dense
          />
        </v-card-text>

        <v-card-actions class="justify-end">
          <v-btn text @click="dialogObs = false">
            Cancelar
          </v-btn>

          <v-btn color="red" dark @click="confirmarObservacion">
            Observar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="showModal" max-width="500">
      <v-card>
        <v-card-title>
          Nueva valorización
        </v-card-title>

        <v-card-text>
          <v-select
            label="Moneda"
            :items="monedas"
            item-title="text"
            item-value="value"
            v-model="cotizacion.moneda"
            outlined dense
          />

          <v-text-field
            label="Monto"
            type="number"
            v-model.number="cotizacion.monto"
            :prefix="cotizacion.moneda === 'PEN' ? 'S/ ' : '$ '"
            outlined dense
          />

          <v-textarea
            label="Observaciones"
            v-model="cotizacion.detalle_cotizacion"
            outlined dense
          />

        </v-card-text>

        <v-card-actions class="justify-end">
          <v-btn text @click="showModal = false">
            Cancelar
          </v-btn>

          <v-btn color="primary" @click="guardarCotizacion">
            Enviar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- SNACKBAR -->
    <v-snackbar
      v-model="snackbar.show"
      :color="snackbar.color"
      :timeout="3000"
      top
    >
      {{ snackbar.text }}
    </v-snackbar>

  </v-container>
</template>

<script>
import axios from 'axios'

export default {
  name: 'CotizacionContratista',

  data () {
    return {
      requerimientos: [],
      idcontratista: null,

      showModal: false,
      dialogObs: false,
      cotizacionSeleccionada: null,
      observacion: '',

      cotizacion: {
        monto: null,
        detalle_cotizacion: '',
        moneda: 'PEN'
      },

      monedas: [
        { text: 'Soles (PEN)', value: 'PEN' },
        { text: 'Dólares (USD)', value: 'USD' }
      ],

      snackbar: {
        show: false,
        text: '',
        color: 'success'
      },
      filtros: {
        proveedor: null,
        contratista: null,
        estado: null
      },
    }
  },

  created () {
    this.idusuario = localStorage.getItem('idusuario')
    this.rol = localStorage.getItem('rol')
    this.empresaid = localStorage.getItem('empresa')
    this.empresaid = this.empresaid ? Number(this.empresaid) : null
    this.id_contratista = localStorage.getItem('empresacontratista')
    this.id_contratista = this.idcontratista ? Number(this.idcontratista) : null
    this.esAdmin =
    this.rol === 'ADMINISTRADOR'
    this.listar()
  },

  computed: {
    // requerimientosFiltrados () {
    //   if (!this.requerimientos || !this.requerimientos.length) return []

    //   const grouped = {}

    //   this.requerimientos.forEach(r => {

    //     // 🔹 Crear requerimiento si no existe
    //     if (!grouped[r.idrequerimiento]) {
    //       grouped[r.idrequerimiento] = {
    //         idrequerimiento: r.idrequerimiento,
    //         codigo: r.codigo,
    //         denominacion: r.denominacion,
    //         empresa_contacto: r.empresa_contacto,
    //         nombre_categoria: r.nombre_categoria,
    //         detalles: [],
    //         empresas: {}
    //       }
    //     }

    //     const req = grouped[r.idrequerimiento]

    //     // 🔹 DETALLES (sin duplicar)
    //     if (Array.isArray(r.detalles) && r.detalles.length) {
    //       r.detalles.forEach(d => {
    //         if (!req.detalles.some(x => x.iddetalles === d.iddetalles)) {
    //           req.detalles.push(d)
    //         }
    //       })
    //     }

    //     // 🔹 EMPRESA
    //     if (!req.empresas[r.empresaId]) {
    //       req.empresas[r.empresaId] = {
    //         id_empresa: r.empresaId,
    //         razonsocial: r.razonsocial || `Empresa ${r.empresaId}`,
    //         cotizaciones: []
    //       }
    //     }

    //     const empresa = req.empresas[r.empresaId]

    //     // 🔹 COTIZACIONES (sin duplicar)
    //     if (Array.isArray(r.cotizaciones) && r.cotizaciones.length) {
    //       r.cotizaciones.forEach(c => {
    //         if (!empresa.cotizaciones.some(x => x.id_cotizacion === c.id_cotizacion)) {
    //           empresa.cotizaciones.push(c)
    //         }
    //       })
    //     }

    //   })

    //   // 🔥 Convertir a array + ordenar cotizaciones
    //   const resultado = Object.values(grouped).map(r => ({
    //     ...r,
    //     empresas: Object.values(r.empresas).map(e => ({
    //       ...e,
    //       cotizaciones: e.cotizaciones.sort((a, b) => b.version - a.version)
    //     }))
    //   }))

    //   // console.log('FINAL AGRUPADO:', resultado)

    //   return resultado
    // }
    listaProveedores () {
      return [
        ...new Set(
          this.requerimientos
            .map(r => r.razonsocial)
            .filter(Boolean)
        )
      ]
    },

    listaContratistas () {
      return [
        ...new Set(
          this.requerimientos
            .map(r => r.empresa_contacto)
            .filter(Boolean)
        )
      ]
    },

    listarEstados () {
      return [
        'APROBADO',
        'OBSERVADO',
        'PENDIENTE',
        'SIN VALORIZACIONES'
      ]
    },

    requerimientosFiltrados () {

      if (!this.requerimientos?.length) return []

      const grouped = {}

      this.requerimientos.forEach(r => {

        if (!grouped[r.idrequerimiento]) {

          grouped[r.idrequerimiento] = {
            idrequerimiento: r.idrequerimiento,
            codigo: r.codigo,
            denominacion: r.denominacion,
            empresa_contacto: r.empresa_contacto,
            nombre_categoria: r.nombre_categoria,
            detalles: [],
            empresas: {}
          }
        }

        const req = grouped[r.idrequerimiento]

        if (Array.isArray(r.detalles)) {

          r.detalles.forEach(d => {

            if (!req.detalles.some(x => x.iddetalles === d.iddetalles)) {
              req.detalles.push(d)
            }
          })
        }

        if (!req.empresas[r.empresaId]) {

          req.empresas[r.empresaId] = {
            id_empresa: r.empresaId,
            razonsocial: r.razonsocial || '',
            cotizaciones: []
          }
        }

        const empresa = req.empresas[r.empresaId]

        if (Array.isArray(r.cotizaciones)) {

          r.cotizaciones.forEach(c => {

            if (!empresa.cotizaciones.some(
              x => x.id_cotizacion === c.id_cotizacion
            )) {
              empresa.cotizaciones.push(c)
            }
          })
        }
      })

      return Object.values(grouped)

        .map(req => {

          let empresas = Object.values(req.empresas)

          empresas = empresas
            .map(emp => ({
              ...emp,
              cotizaciones: emp.cotizaciones
                .sort((a,b)=>b.version-a.version)
            }))
            .filter(emp => {

              if (
                this.filtros.proveedor &&
                emp.razonsocial !== this.filtros.proveedor
              ) {
                return false
              }

              if (
                this.filtros.contratista &&
                req.empresa_contacto !== this.filtros.contratista
              ) {
                return false
              }

              if (!this.filtros.estado) {
                return true
              }

              if (
                this.filtros.estado ===
                'SIN VALORIZACIONES'
              ) {
                return !emp.cotizaciones.length
              }

              return emp.cotizaciones.some(
                c => c.estado === this.filtros.estado
              )
            })

          return {
            ...req,
            empresas
          }
        })

        .filter(req => req.empresas.length > 0)
    }
  },

  methods: {

    listar () {
      axios
        .get(`api/CotizacionRequerimientos/ListarPorEmpresaContra/${this.idusuario}`)
        .then(res => {
          this.requerimientos = res.data
        })
    },

    formatFecha (f) {
      return f ? new Date(f).toLocaleDateString() : ''
    },

    esUltima (cot, empresa) {
      const ultima = empresa.cotizaciones[0]
      return ultima.id_cotizacion === cot.id_cotizacion
    },

    estadoClase (estado) {
      if (estado === 'APROBADO') return 'badge-verde'
      if (estado === 'OBSERVADO') return 'badge-rojo'
      return 'badge-amarillo'
    },

    async aprobar (cot) {
      try {
        await axios.put('api/CotizacionRequerimientos/Aprobar', {
          idCotizacion: cot.id_cotizacion
        })

        this.snackbar = {
          show: true,
          text: 'Valorización aprobada',
          color: 'success'
        }

        this.listar()

      }
      catch (e){
        this.snackbar = {
          show: true,
          text: 'Error al aprobar',
          color: 'error'
        }
      }
    },

    abrirObservacion (cot) {
      this.cotizacionSeleccionada = cot
      this.observacion = ''
      this.dialogObs = true
    },

    async confirmarObservacion () {
      try {
        await axios.put('api/CotizacionRequerimientos/Observar', {
          idCotizacion: this.cotizacionSeleccionada.id_cotizacion,
          observacion: this.observacion
        })

        this.snackbar = {
          show: true,
          text: 'Valorización observada',
          color: 'success'
        }

        this.dialogObs = false
        this.listar()

      } catch (e){
        this.snackbar = {
          show: true,
          text: 'Error al observar',
          color: 'error'
        }
      }
    },
    detallesTexto(detalles) {
      if (!detalles || !detalles.length) return ''
      return detalles.map(d => d.detalle).join(', ')
    },
    detallesTextoServicio(detalles) {
      if (!detalles || !detalles.length) return ''
      return detalles.map(d => d.servicio).join(', ')
    },
    formatearFecha(fecha){
      if(!fecha) return ''
      return new Date(fecha).toLocaleDateString()
    },
    esTransporteLiviano(item){
      return (
        item.nombre_categoria &&
        item.nombre_categoria.toUpperCase() ===
        'TRANSPORTE LIVIANO Y DE PERSONAL'
      )
    },
    abrirModal (item, empresa) {
      this.postulacionActual = item
      this.cotizacion = {
        monto: null,
        detalle_cotizacion: ''
      }
      this.showModal = true
      this.empresa_id_enviar = empresa.id_empresa
    },
    async guardarCotizacion () {
      try {
        var formData = new FormData()

        formData.append('monto', this.cotizacion.monto)
        formData.append('moneda', this.cotizacion.moneda)
        formData.append('detalle_cotizacion', this.cotizacion.detalle_cotizacion)
        formData.append('idrequerimiento', this.postulacionActual.idrequerimiento)
        formData.append('id_empresa', this.empresa_id_enviar)

        await axios.post(
          'api/CotizacionRequerimientos/Crear',
          formData
        )

        this.showModal = false

        this.snackbar = {
          show: true,
          text: 'Valorización enviada correctamente',
          color: 'success'
        }

        this.postulaciones = []
        await this.listarPostulaciones()

      } catch (error) {
        this.snackbar = {
          show: true,
          text: 'Error al enviar valorización',
          color: 'error'
        }
      }
    },
    puedeSubir (item) {
      if (!item.cotizaciones || !item.cotizaciones.length) return true

      var ordenadas = this.ordenarCotizaciones(item.cotizaciones)
      var ultima = ordenadas[0]

      return ultima.estado === 'OBSERVADO'
    },
  }
}
</script>

<style scoped>
.badge {
  padding: 4px 10px;
  border-radius: 12px;
  font-size: 11px;
  font-weight: 600;
}

.badge-verde {
  background: #16a34a;
  color: white;
}

.badge-amarillo {
  background: #facc15;
  color: black;
}

.badge-rojo {
  background: #dc2626;
  color: white;
}

.btn-aprobar {
  background-color: #16a34a !important;
  color: white !important;
}

.btn-observar {
  background-color: #dc2626 !important;
  color: white !important;
}
.req-title {
  font-size: 18px;
  font-weight: 700;
}

.req-subtitle {
  font-size: 14px;
  color: #6b7280;
}
</style>